export default __webpack_public_path__ + "static/media/image.gurusinghe-foundation.6425ee4a.png";